/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { ClientRequestConfigType, ClientType } from '../../types/client-type'
import { HEADER_X_AUTH_TOKEN, R_HEADER_X_REFERRAL_ID, X_AUTH_TOKEN } from '../CONSTANT_HEADERS'
import {
  COOKIES_NAME_REFERRAL_ID,
  COOKIES_NAME_UTM_CAMPAIGN,
  COOKIES_NAME_UTM_MEDIUM,
  COOKIES_NAME_UTM_SOURCE,
  deleteCookie,
  getCookie
} from '../Cookies'
const createDurationLog = (url, promise) => {
  // const fetchEvent = `api fetch ${url}`
  // eslint-disable-next-line no-console
  // console.time(fetchEvent)
  return promise.then((value) => {
    // eslint-disable-next-line no-console
    // console.timeEnd(fetchEvent)
    return value
  })
}
const createRequestMethod = <T>(axiosInstance: AxiosInstance, onUnauthorization?: () => void, onForbidden?: () => void) => (
  apiPath: string,
  requestConfig: ClientRequestConfigType
): Promise<AxiosResponse<T>> => {
  const headers = { ...requestConfig.headers, 'Referrer-Policy': 'no-referrer-when-downgrade' }
  // headers['Accept-Language'] = 'en'
  const utmPrams = {}
  if (!requestConfig.ignoreAuthentication && getCookie(HEADER_X_AUTH_TOKEN)) {
    headers.Authorization = `${getCookie(HEADER_X_AUTH_TOKEN)}`
  }
  if (getCookie(COOKIES_NAME_REFERRAL_ID)) {
    headers[R_HEADER_X_REFERRAL_ID] = getCookie(COOKIES_NAME_REFERRAL_ID)
  }
  if (getCookie(COOKIES_NAME_UTM_SOURCE)) {
    headers[COOKIES_NAME_UTM_SOURCE] = getCookie(COOKIES_NAME_UTM_SOURCE)
    utmPrams[COOKIES_NAME_UTM_SOURCE] = getCookie(COOKIES_NAME_UTM_SOURCE)
  }
  if (getCookie(COOKIES_NAME_UTM_CAMPAIGN)) {
    headers[COOKIES_NAME_UTM_CAMPAIGN] = getCookie(COOKIES_NAME_UTM_CAMPAIGN)
    utmPrams[COOKIES_NAME_UTM_CAMPAIGN] = getCookie(COOKIES_NAME_UTM_CAMPAIGN)
  }
  if (getCookie(COOKIES_NAME_UTM_MEDIUM)) {
    headers[COOKIES_NAME_UTM_MEDIUM] = getCookie(COOKIES_NAME_UTM_MEDIUM)
    utmPrams[COOKIES_NAME_UTM_MEDIUM] = getCookie(COOKIES_NAME_UTM_MEDIUM)
  }
  return createDurationLog(
    apiPath,
    axiosInstance
      .request({
        url: apiPath,
        ...requestConfig,
        params: { ...(requestConfig.sendUTM ? utmPrams : {}), ...requestConfig.params },
        headers
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (!requestConfig.preventRedirect && error.response && error.response.status === 401) {
          if (location.pathname.indexOf('/login') !== 0) {
            //@ts-ignore
            if (typeof window?.Gleap === 'function') {
              //@ts-ignore
              window.Gleap.clearIdentity()
            }
            deleteCookie(X_AUTH_TOKEN)
            localStorage.setItem('AUTHENTICATION_TOKEN', '')
            onUnauthorization && onUnauthorization()
            // window.location.href = `/login`
            throw new Error(`Server API 401`)
          }
        }
        if (!requestConfig.preventRedirect && error.response && error.response.status === 403) {
          //@ts-ignore
          if (typeof window?.Gleap === 'function') {
            //@ts-ignore
            window.Gleap.clearIdentity()
          }
          deleteCookie(X_AUTH_TOKEN)
          localStorage.setItem('AUTHENTICATION_TOKEN', '')
          onForbidden && onForbidden()
          throw new Error(`Server API 403`)
        }
        if (error.response && error.response.status === 500) {
          throw new Error(`Server api call 500 Error ${apiPath}`)
        }
        throw error
      })
  )
}
export function createAPIClient(endpoint): ClientType {
  const instance = axios.create({
    // eslint-disable-next-line no-undef
    baseURL: endpoint,
    // timeout: "",
    withCredentials: true
  })
  return {
    get: <T>(path: string, options: ClientRequestConfigType) =>
      createRequestMethod<T>(instance)(path, {
        method: 'get',
        ...options
      }),
    post: <T>(path: string, options: ClientRequestConfigType) =>
      createRequestMethod<T>(instance)(path, {
        method: 'post',
        ...options
      }),
    put: <T>(path: string, options: ClientRequestConfigType) =>
      createRequestMethod<T>(instance)(path, {
        method: 'put',
        ...options
      }),
    patch: <T>(path: string, options: ClientRequestConfigType) =>
      createRequestMethod<T>(instance)(path, {
        method: 'patch',
        ...options
      }),
    delete: <T>(path: string, options: ClientRequestConfigType) =>
      createRequestMethod<T>(instance)(path, {
        method: 'delete',
        ...options
      })
  }
}
